"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Broadcast/Modals/QueueMessages/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);



var _actions = require('shared/actions'); var _actions2 = _interopRequireDefault(_actions);




var _broadcast = require('shared/selectors/broadcast');
var _campaignRecipientsAdds = require('shared/selectors/campaignRecipientsAdds');
var _hooks = require('web/services/hooks');
var _scheduleTimeZone = require('web/services/scheduleTimeZone');
var _campaignState = require('web/screens/Broadcast/campaignState');

var _Form = require('./Form'); var _Form2 = _interopRequireDefault(_Form);
var _Modal = require('web/components/Modal'); var _Modal2 = _interopRequireDefault(_Modal);
var _Spinner = require('web/components/Spinner');
var _GateSummary = require('./GateSummary');


















const QueueMessagesModal = ({
  campaignKey,
  isOpen, onClose, onStartCampaign,
  refusedGate, onReviewRecipients, onFixMessage,
}) => {
  const campaign = _hooks.useAppSelector.call(void 0, state => _broadcast.selectCampaignByKey.call(void 0, state, campaignKey))
  // Rev 33 T2: a paused campaign's Resume… opens these same two dialogs.
  const isResume = !!campaign && _campaignState.isPausedCampaign.call(void 0, campaign)
  const messageDelay = _hooks.useAppSelector.call(void 0, state => _broadcast.selectCampaignMessageDelay.call(void 0, state, campaignKey))
  const notScheduledCount = _hooks.useAppSelector.call(void 0, 
    state => _broadcast.selectCampaignNotScheduledCount.call(void 0, state, campaignKey),
  )
  // The server's batch-size setting (FindCampaigns).
  const maxBatchSize = _hooks.useAppSelector.call(void 0, _campaignRecipientsAdds.selectMaxBatchSize)
  // The same zone, remembered the same way, as a chat's Send later.
  const { timeZone, setTimeZone } = _scheduleTimeZone.useScheduleTimeZone.call(void 0, )

  // The launch gate runs each time the dialog opens, so it can refuse before
  // anything is queued (mockup 07). The server gates Start again regardless.
  const [check, setCheck] = _react.useState({ isLoading: false, gate: null })
  _react.useEffect.call(void 0, 
    () => {
      if (!isOpen || refusedGate) return
      let isCurrent = true
      setCheck({ isLoading: true, gate: null })
      _actions2.default.checkCampaignGate({ CampaignKey: campaignKey })
        .then(gate => { if (isCurrent) setCheck({ isLoading: false, gate }) })
        .catch(e => {
          log.error(e)
          if (isCurrent) setCheck({ isLoading: false, gate: null })
        })
      return () => { isCurrent = false }
    },
    [isOpen, refusedGate, campaignKey],
  )

  // Rev 28 R2: a pace changed in the dialog is a campaign setting, saved
  // like Details saves it.
  const onSavePace = _react.useCallback.call(void 0, 
    (MessageDelay) => campaign
      ? _actions2.default.updateCampaign({
        CampaignKey: campaign.CampaignKey,
        Name: campaign.Name,
        TeamKey: campaign.TeamKey,
        SenderKey: campaign.SenderKey,
        MessageType: campaign.MessageType,
        MessageTemplate: campaign.MessageTemplate,
        MessageDelay,
      })
      : Promise.reject(new Error('No campaign')),
    [campaign],
  )

  // Review R800-43: no closing while a pace save (and the start after it) is out.
  const [isSaving, setIsSaving] = _react.useState.call(void 0, false)
  _react.useEffect.call(void 0, () => { if (!isOpen) setIsSaving(false) }, [isOpen])

  // Rev 29 Y4: focus goes back to what opened the dialog (Send…) when it
  // closes. The opener is read in
  // a layout effect, before the form moves focus into the dialog; it is
  // refocused from a passive cleanup, because React puts focus back on the
  // dialog's focused element at the end of the commit that closes it.
  const openerRef = _react.useRef(null)
  _react.useLayoutEffect.call(void 0, 
    () => { if (isOpen) openerRef.current = document.activeElement  },
    [isOpen],
  )
  _react.useEffect.call(void 0, 
    () => {
      if (!isOpen) return
      return () => {
        const opener = openerRef.current
        openerRef.current = null
        if (_optionalChain([opener, 'optionalAccess', _ => _.isConnected])) opener.focus()
      }
    },
    [isOpen],
  )

  const gate = _nullishCoalesce(refusedGate, () => ( check.gate))
  const isBlocked = !!gate && !gate.Ready

  const renderBody = () => {
    if (!refusedGate && check.isLoading) {
      return _react2.default.createElement('div', { className: "broadcast-gate--loading", __self: this, __source: {fileName: _jsxFileName, lineNumber: 122}}, _react2.default.createElement(_Spinner.SimpleSpinner, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 122}} ))
    }
    if (gate && isBlocked) {
      return (
        _react2.default.createElement(_react2.default.Fragment, null
          , _react2.default.createElement(_GateSummary.GateRefusal, { gate: gate, __self: this, __source: {fileName: _jsxFileName, lineNumber: 127}} )
          , _react2.default.createElement(_Modal.ModalControls, {
            secondaryBtnLabel: "Review recipients" ,
            onSecondaryBtnClick: onReviewRecipients,
            primaryBtnLabel: "Fix the message"  ,
            onPrimaryBtnClick: onFixMessage, __self: this, __source: {fileName: _jsxFileName, lineNumber: 128}}
          )
        )
      )
    }
    // Rev 31 Q6: skipped recipients aren't sent, so the batch is the ready ones
    // not yet queued or being sent (review R800-69).
    const sendable = gate
      ? _nullishCoalesce(gate.QueueableRecipients, () => ( Math.min(notScheduledCount, gate.ReadyRecipients)))
      : notScheduledCount
    return (
      _react2.default.createElement(_Form2.default, {
        // Remount when the count changes so the default batch size is re-derived
        // instead of being patched by an effect after render.
        key: sendable,
        onClose: onClose,
        isResume: isResume,
        gate: gate,
        messageDelay: messageDelay,
        notScheduledCount: sendable,
        maxBatchSize: maxBatchSize,
        onStartCampaign: onStartCampaign,
        onSavePace: onSavePace,
        onSavingChange: setIsSaving,
        timeZone: timeZone,
        onTimeZoneChange: setTimeZone, __self: this, __source: {fileName: _jsxFileName, lineNumber: 143}}
      )
    )
  }

  return (
    _react2.default.createElement(_Modal2.default, {
      title: isResume ? 'Resume' : 'Send',
      isOpen: isOpen,
      onClose: isSaving ? undefined : onClose,
      size: "xs",
      className: "broadcast-gate--modal", __self: this, __source: {fileName: _jsxFileName, lineNumber: 163}}

      ,  renderBody() 
    )
  )
}

exports. default = _react.memo.call(void 0, QueueMessagesModal)
